import Image from 'next/image';
import type { PropsWithChildren, Ref } from 'react';

const BADGE_SRC = 'https://www.nerdwallet.com/cdn/wealth/icons/best_of_awards_2026_badge.svg';
const FLAG_TAIL_WIDTH_PX = 20;
export const BANNER_HEIGHT_FIXED_PX = 32;

export interface BestOfAwardsRoundupBannerProps extends PropsWithChildren {
  variant?: 'row' | 'row-compact' | 'card';
  ref?: Ref<HTMLDivElement>;
  className?: string;
}

export function BestOfAwardsRoundupBanner({
  children,
  className,
  ref,
  variant = 'row',
}: BestOfAwardsRoundupBannerProps) {
  if (variant === 'card') {
    return (
      <div ref={ref} className={`@container flex w-full items-start ${className ?? ''}`}>
        <span className="inline-flex">
          <Image
            alt="NerdWallet Best-Of Awards"
            height={56}
            src={BADGE_SRC}
            unoptimized
            width={45}
            style={{ objectFit: 'cover' }}
          />
        </span>
        <span className="min-h-10 rounded-r-[4px] bg-accent px-3 py-1 @sm:w-full">
          {/* Theme/index.ts:1034 accent line-height and tracking lack Tailwind scale equivalents. */}
          <span className="text-accent-foreground text-sm leading-[15px] font-bold uppercase tracking-[0.8125px]">
            {children}
          </span>
        </span>
      </div>
    );
  }

  const isRow = variant === 'row';

  return (
    <div ref={ref} className={`@container flex w-full ${className ?? ''}`}>
      <span className={`inline-flex bg-accent pl-3 ${isRow ? 'h-8' : ''}`}>
        <Image
          alt="NerdWallet Best-Of Awards"
          height={isRow ? 40 : 32}
          src={BADGE_SRC}
          unoptimized
          width={isRow ? 32 : 26}
          style={{ objectFit: 'cover' }}
        />
      </span>
      <span
        className={`flex bg-accent py-1 pr-7 pl-3 ${isRow ? 'h-8' : '@sm:w-full'}`}
        style={{
          clipPath: `polygon(0 0, 100% 0, calc(100% - ${FLAG_TAIL_WIDTH_PX / 2}px) 50%, 100% 100%, 0 100%)`,
        }}
      >
        <span className="typography-text-extra-small flex items-center text-accent-foreground font-bold uppercase">
          {children}
        </span>
      </span>
    </div>
  );
}
